import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AssetsSkeleton() {
  return (
    <SkeletonTheme baseColor="#373737" highlightColor="#C0C0C0">
      <div className="flex items-center justify-between">
        <div className="flex items-center w-[40%] gap-3">
          <div className="flex items-center gap-3">
            <Skeleton
              count={1}
              width={"36px"}
              height={"36px"}
              style={{ borderRadius: "100%" }}
            />

            <div className="flex flex-col h-[36px] gap-0">
              <div style={{ height: "40px", overflow: "hidden" }}>
                <Skeleton
                  count={1}
                  width={"100px"}
                  height={"14px"}
                  style={{ borderRadius: "8px" }}
                />
              </div>
              <div style={{ height: "40px", overflow: "hidden" }}>
                <Skeleton
                  count={1}
                  width={"100px"}
                  height={"14px"}
                  style={{ borderRadius: "8px", lineHeight: "normal" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="text-left">
          <div className="flex flex-col gap-0 items-end">
            
            <Skeleton
              count={1}
              width={"50px"}
              height={"20px"}
              style={{ borderRadius: "8px" }}
            />
            <Skeleton
              count={1}
              width={"50px"}
              height={"20px"}
              style={{ borderRadius: "8px" }}
            />
          </div>
        </div>
        <div className="text-right">
          <div className="flex flex-col gap-0 items-end">
            <Skeleton
              count={1}
              width={"50px"}
              height={"20px"}
              style={{ borderRadius: "8px" }}
            />
            <Skeleton
              count={1}
              width={"50px"}
              height={"20px"}
              style={{ borderRadius: "8px" }}
            />
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
}

export default AssetsSkeleton;
